/* eslint-disable no-unused-vars */
import _ from "lodash";
import imask from "imask";
import cpf from "cpf";
import isEmail from "validator/lib/isEmail";
import isEmpty from "validator/lib/isEmpty";

export const CEP_REGEX = /^\d{5}-\d{3}?$/;
export const TELEFONE_REGEX = /\(\d{2}\)\s\d{4,5}-?\d{4}/;
export const PASSWORD_REGEX =
  /(?=.{6,}$)(?=.*?[a-z]|[A-Z])(?=.*?[0-9])|(?=.{6,}$)(?=.*?[0-9])/;
export const NUMERO_ANO = /^\d{4}?$/;

// COMMONS
export const obrigatorio = (value, all, props) => {
  if (value === undefined || isEmpty(value)) {
    return "LABELS.VALIDACAO.CAMPO.OBRIGATORIO";
  }

  if (typeof value === "object" && _.isEmpty(value)) {
    return "LABELS.VALIDACAO.CAMPO.OBRIGATORIO";
  }

  if (typeof value !== "object" && isEmpty(value)) {
    return "LABELS.VALIDACAO.CAMPO.OBRIGATORIO";
  }

  return undefined;
};

// Checkbox
export const checkboxObrigatorio = (value, all, props) => {
  if (!value) {
    return "LABELS.VALIDACAO.CAMPO.OBRIGATORIO";
  }

  return undefined;
};

// CPF
const CPF_MASK = imask.createMask({ mask: "000.000.000-00" });

export const formatCpf = (value, all, props) => {
  return CPF_MASK.resolve(value);
};

export const validateCpf = (value, all, props) => {
  if (cpf.isValid(value)) {
    return undefined;
  }

  return "LABELS.VALIDACAO.CAMPO.CPF_INVALIDO";
};

// EMAIL
export const validateEmail = (value, all, props) => {
  if (isEmail(value)) {
    return undefined;
  }

  return "LABELS.VALIDACAO.CAMPO.EMAIL_INVALIDO";
};

export const emailConfirmantion = (value, all, props) => {
  if (value !== all.email) {
    return "LABELS.VALIDACAO.CAMPO.EMAIL.CONFIRMACAO";
  }

  return undefined;
};

export const maxLength50Validation = (value, all, props) => {
  if (value.length > 50) {
    return "LABELS.VALIDACAO.CAMPO.MAXIMO.CARACTERES.50"
  }

  return undefined;
};

export const maxLength100Validation = (value, all, props) => {
  if (value.length > 100) {
    return "LABELS.VALIDACAO.CAMPO.MAXIMO.CARACTERES.100"
  }

  return undefined;
};

// CPF & CNPJ
export const formatCpfCnpj = (value) => {
  if (value.length > 14) {
    return formatCnpj(value);
  }

  return formatCpf(value);
};

export const validateCpfCnpj = (value) => {
  if (value.length > 14) {
    return validateCnpj(value);
  }

  return validateCpf(value);
};

// CNPJ
const CNPJ_MASK = imask.createMask({ mask: "**.***.***/****-00" });

export const formatCnpj = (value) => {
  return CNPJ_MASK.resolve(value);
};

export const validateCnpj = (value) => {
  if (validaCnpj(value)) {
    return undefined;
  }

  return "LABELS.VALIDACAO.CAMPO.CNPJ_INVALIDO";
};

// CEP
const CEP_MASK = imask.createMask({ mask: "00000-000" });

export const formatCep = (value) => {
  return CEP_MASK.resolve(value);
};

export const validateCep = (value) => {
  if (CEP_REGEX.test(value)) {
    return undefined;
  }

  return "LABELS.VALIDACAO.CAMPO.CEP_INVALIDO";
};

// TELEFONE
const TELEFONE_MASK = imask.createMask({ mask: "(00) 0000-0000" });
const CELULAR_MASK = imask.createMask({ mask: "(00) 00000-0000" });
// imask aceita array de mask porem nao consegue efetuar o '.resolve'
// sempre valida com a primeira mask configurada
// criadas duas mask para validar o telefone

export const formatRawTelefone = (value) => {
  return value.length > 10 ? CELULAR_MASK.resolve(value) : TELEFONE_MASK.resolve(value);
};

export const formatTelefone = (value) => {
  if (value.length > 14) {
    return CELULAR_MASK.resolve(value);
  }

  return TELEFONE_MASK.resolve(value);
};

export const validateTelefone = (value) => {
  if (value.length > 14) {
    if (TELEFONE_REGEX.test(value)) {
      return undefined;
    }

    return "LABELS.VALIDACAO.CAMPO.TELEFONE_INVALIDO";
  }

  if (TELEFONE_REGEX.test(value)) {
    return undefined;
  }

  return "LABELS.VALIDACAO.CAMPO.TELEFONE_INVALIDO";
};

// ANO
export const validateNuAno = (value, all, props) => {
  if (NUMERO_ANO.test(value)) {
    return undefined;
  }

  return "LABELS.VALIDACAO.CAMPO.EMAIL_INVALIDO";
};

// PASSWORD
export const validatePassword = (value, all, props) => {
  const regex = new RegExp(props.passwordValidation.regex);
  const message = props.passwordValidation.message;
  return regex.test(value) ? undefined : message;
};

export const passwordConfirmation = (value, all, props) => {
  if (value === all.senha || value === all.senhaNova) {
    return undefined;
  }

  return "LABELS.VALIDACAO.CAMPO.SENHA.CONFIRMACAO";
};

export const testRegex = (regex, value) => regex.test(value);

export const validaCpf = cpf => {
  // Remove caracteres não numéricos
  cpf = cpf.replace(/[^\d]/g, '');

  // Verifica se o CPF tem 11 dígitos
  if (cpf.length !== 11) {
      return false;
  }

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cpf)) {
      return false;
  }

  // Calcula o primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digito1 = (resto >= 10) ? 0 : resto;

  // Calcula o segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  let digito2 = (resto >= 10) ? 0 : resto;

  // Verifica se os dígitos verificadores são iguais aos calculados
  return (digito1 === parseInt(cpf.charAt(9)) && digito2 === parseInt(cpf.charAt(10)));
}

const charToInt = (c) => {
  return c.charCodeAt(0) - 48;
};

const calcularDV = (base, multiplicadores) => {
  let soma = 0;

  for (let i = 0; i < multiplicadores.length; i++) {
    soma += charToInt(base.charAt(i)) * Number(multiplicadores.charAt(i));
  }

  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
};

export const validaCnpj = value => {
  if (!value || typeof value !== "string") {
    return false;
  }

  const cnpj = value
    .trim()
    .replace(/[./-]/g, "")
    .toUpperCase();

  // Doze posições alfanuméricas e dois DVs obrigatoriamente numéricos.
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) {
    return false;
  }

  if (/^(.)\1+$/.test(cnpj)) {
    return false;
  }

  const base = cnpj.substring(0, 12);
  const dvInformado = cnpj.substring(12);
  const dv1 = calcularDV(base, '543298765432');
  const dv2 = calcularDV(base + dv1, '6543298765432');

  return `${dv1}${dv2}` === dvInformado;
};
